import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getPerson} from "../../api/routes";
import queryString from "../../functions/queryString";
import {toast} from "react-toastify";
import Loading from "../../components/Loading";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import InfiniteScroll from "react-infinite-scroll-component";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import PersonTable from "./PersonTable";

export default function Person() {
    const [searchParams] = useSearchParams()
    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [person, setPerson] = useState([]);
    const [trigger, setTrigger] = useState(null);
    const [searchInfo, setSearchInfo] = useState({});
    const handleChange = (event) => {
        const {name, value} = event.target;
        setSearchInfo({[name]: value});
    };
    const handleClickFilter = () => {
        if (page === 0)
            setTrigger(Math.random());
        else
            setPage(0);

        setCursor(null);
    }

    useEffect(() => {
        setLoading(true);
        const query = {
            cursor: cursor === null ? null : cursor,
            full_name: searchInfo?.full_name ? searchInfo?.full_name : null,
            username: searchInfo?.username ? searchInfo?.username: null,
            phone_number: searchInfo?.phone_number ? searchInfo?.phone_number: null,
        }
        getPerson(queryString(query), (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message)
            } else {
                if (page !== 0) {
                    setPerson((prev) => ([...prev, ...data.data]));
                } else {
                    setPerson(data.data);
                }
                setLoading(false);
                setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                if (data.meta.next_cursor !== null)
                    return setHasMore(true);

                else return setHasMore(false)
            }
        }, trigger !== null)

    }, [page, trigger]);
    useEffect(() => {
        if (searchParams.get("update")) {
            if (page === 0)
                setTrigger(Math.random());
            else
                setPage(0);

            setCursor(null);
        }
    }, [searchParams.get("update")]);
    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }
    return (
        <DashboardLayout>
            <Loading loading={loading}/>
            <DashboardNavbar/>
            <InfiniteScroll dataLength={person.length} next={fetchMoreData} hasMore={hasMore}>
                <PersonTable data={person} searchInfo={searchInfo} handleFilterChange={handleChange}
                             handleClickFilter={handleClickFilter}/>
            </InfiniteScroll>
        </DashboardLayout>
    )
}
